import type { Meta, StoryFn } from '@storybook/react';

import { Alert } from '@pega/cosmos-react-core';
import type { AlertProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Badges/Alert',
  component: Alert
} as Meta;

export const AlertBadge: StoryFn<AlertProps> = (args: AlertProps) => {
  return <Alert variant={args.variant} />;
};

AlertBadge.args = {
  variant: 'success'
};

AlertBadge.argTypes = {
  variant: { options: ['success', 'urgent'], control: { type: 'select' } }
};
